import commonMixin from './../mixins/_common';
import modalMixin from './../mixins/_modal';
import flashMessageMixin from './../mixins/_flash_messages';
import modalCustomPageSelecter from './_modal_custom_page_selecter';
import modalOthersPageSelecter from './_modal_others_page_selecter';
import modalCategoryEdit from './../components/category/_modal_category_edit';
import { eventBus } from '@/helpers/_event_bus';

/**
 * リンク選択コンポーネント
 */
export default {
    name: 'LinkSelecter',
    template: '#link_selecter_template',
    data() {
        return {
            // 表示モード
            display: null,
            // リンク先URL
            url: '',
            // 呼び出し元パーツID
            componentId: '',
            // 各モーダルコンポーネントの描画フラグ
            output_modal: false,
            // モーダル呼び出し元のパーツ編集データindex
            index: null,
        };
    },
    mixins: [
        commonMixin,
        modalMixin,
        flashMessageMixin,
    ],
    components: {
        // カテゴリ管理コンポーネント
        'modal-category-edit': modalCategoryEdit,
        // カスタムページ選択コンポーネント
        'modal-custom-page-selecter': modalCustomPageSelecter,
        // 「その他」ページ選択コンポーネント
        'modal-others-page-selecter': modalOthersPageSelecter,
    },
    created: function () {
        // イベントバスでモーダル発火の指示を受け取る
        eventBus.$on('open_modal_link_selecter', (data) => {
            const {componentId, linkUrl, index } = data;
            this.componentId = componentId;
            this.index = index;
            this.linkUrl = linkUrl;
            this.openModalLinkSelecter();
        });
        // イベントバスで商品選択結果を受け取る
        eventBus.$on('result_for_link_selecter', (result) => {
            this.saveUrlByPageKey(result.item_code);
        });
    },
    computed: {
        linkUrl: {
            get() {
                return this.url;
            },
            set(value) {
                if (!value?.trim()) {
                    value = null;
                }
                this.url = value;
            }
        }
    },
    emits: ['update-link-url'],
    methods: {
        // リンク選択モーダルを開く
        openModalLinkSelecter: function () {
            // 多重モーダルの読込フラグをONにする
            this.output_modal = true;
            // モーダルを開く
            this.open();
        },
        // モーダルを開く時に初期化
        opening: function () {
            this.display = 'select_method';
        },
        // 戻るボタンをクリック
        back: function () {
            if (this.display === 'select_method') {
                this.close();
            } else {
                this.display = 'select_method';
            }
        },
        // 商品一覧コンポーネントを開く
        openItemSearch: function () {
            eventBus.$emit('open_modal_item_search', {
                'from': 'link_selecter'
            });
        },
        // カテゴリ一覧コンポーネントを開く
        openModalCategoryEdit: function () {
            this.$refs.modalCategoryEdit.show();
        },
        // カスタムページ選択コンポーネントを開く
        openModalCustomPageSelecter: function () {
            this.$refs.modalCustomPageSelecter.openModal();
        },
        // 「その他」ページ選択コンポーネントを開く
        openModalOthersPageSelecter: function () {
            this.$refs.modalOthersPageSelecter.openModal();
        },
        /**
         * URLを保存する
         * @param url
         */
        saveUrl: function(url) {
            this.linkUrl = url;
            this.closeModal();
        },
        /**
         * pageKeyからURLを生成し保存する
         * @param pageKey
         */
        saveUrlByPageKey: function (pageKey) {
            this.linkUrl = this.generateUrlByPageKey(pageKey);
            this.closeModal();
        },
        // 入力されたURLを保存する
        saveInputUrl: function () {
            this.linkUrl = this.inputUrl;
            this.closeModal();
        },
        // 値を送信してモーダルを閉じる
        closeModal: function () {
            // parts_editorコンポーネントへイベントバスで値を渡す
            // 送信するデータ：{ 更新先データのindex, 更新したいデータ名, 新しいデータ}
            eventBus.$emit('update_' + this.componentId + '_from_event_bus', { index: this.index, name: 'link', newData: this.linkUrl });
            this.close();
        },
        // pagekeyをもとにURLを生成する
        // (2022年4月21日〜Yahoo!側で「/」開始の相対パスが除去対象になったため、「//」からの相対パスに変更)
        // (2022年9月20日〜Android端末を考慮して相対パスから絶対パスに変更)
        generateUrlByPageKey: function (pageKey) {
            return 'https://store.shopping.yahoo.co.jp/' +  this.config.user.shop_id + '/' +  pageKey + '.html';
        }
    },
};
